angular.module('Khayrokom').directive('ngEnter', function() {
    return function(scope, element, attrs) {
        element.bind("keydown keypress", function(event) {
            if(event.which === 13) {
                scope.$apply(function(){
                    scope.$eval(attrs.ngEnter, {'event': event});
                });

                event.preventDefault();
            }
        });
    };
}).directive('ngEscape', function() {
    return function(scope, element, attrs) {
        element.bind("keydown keypress", function(event) {
            if(event.which === 27) {
                scope.$apply(function(){
                    scope.$eval(attrs.ngEscape, {'event': event});
                });

                event.preventDefault();
            }
        });
    };
})
    .directive('ngCount', function() {
     return {
        restrict: 'A',
         scope:{
             trueToggle: '&',
             falseToggle: '&'
         },
        link: function(scope, elem, attrs) {
            $(window).scroll(function() {
                // Show element after user scrolls past
                // the top edge of its parent
                var y = $(this).scrollTop();
                var w = $(this).width();
                if(w<600){
                    $('.videopast').each(function() {
                        var t = $(this).parent().offset().top;

                            if (y > t) {
                                scope.$apply(function () {
                                    scope.trueToggle();
                                })
                            } else {
                                scope.$apply(function () {
                                    scope.falseToggle()
                                })
                            }

                    });
                }
                else if(w<1600){
                    $('.newspast').each(function() {
                        var t = $(this).parent().offset().top;

                        if (y > t) {
                            scope.$apply(function () {
                                scope.trueToggle();
                            })
                        } else {
                            scope.$apply(function () {
                                scope.falseToggle()
                            })
                        }

                    });
                }
            });
        }
    };
})
    .directive('ngSlide', function()    {
    return {
        restrict: 'A',
        scope:{
            itemNumbers: '='
        },
        link: function(scope, elem, attrs) {
            scope.$watch('itemNumbers', function () {
                // vars for clients list carousel
                // http://stackoverflow.com/questions/6759494/jquery-function-definition-in-a-carousel-script
                var fullWidth =$(window).width();
                var w;
                var clients;
                var stat;
                if(fullWidth < 531){
                    clients=1;
                    w=300;
                }else if(fullWidth <676){
                    clients=2;
                }else if(fullWidth <860){
                    clients=3;
                }else if(fullWidth <1100){
                    clients=4;
                }else if(fullWidth <1200){
                    clients=5;
                }else if(fullWidth <1400){
                    clients=6;
                }
                var $clientcarousel = $('.carouselinner');
                $clientcarousel.children().each(function () {
                    // "this" is the current element in the loop
                });
                var children = $clientcarousel.children().length;
                var rotating = true;
                if(children <=clients-1)
                    var rotating=false;

                console.log(clients);
                var clientwidth = (clients * 180); // 140px width for each client item
                $('.owl-carousel').css('width',clientwidth);
                $clientcarousel.css('width',clientwidth);

                var clientspeed = 3000;
                var seeclients = setInterval(rotateClients, clientspeed);
                function rotateClients() {
                    if(rotating != false) {
                        var $first = $('.carouselinner .partnerLogo:first');
                        $first.animate({ 'margin-right': -1*w}, 1000, function() {
                            $first.remove().css({ 'margin-right': '0px' });
                            $('.carouselinner .partnerLogo:last').after($first);
                        });
                    }
                }
            });
            /*$(window).scroll(function() {
                // Show element after user scrolls past
                // the top edge of its parent
                var y = $(this).scrollTop();
                var w = $(this).width();
                if(w<600){
                    $('.videopast').each(function() {
                        var t = $(this).parent().offset().top;

                        if (y > t) {
                            scope.$apply(function () {
                                scope.trueToggle();
                            })
                        } else {
                            scope.$apply(function () {
                                scope.falseToggle()
                            })
                        }

                    });
                }
                else if(w<1600){
                    $('.newspast').each(function() {
                        var t = $(this).parent().offset().top;

                        if (y > t) {
                            scope.$apply(function () {
                                scope.trueToggle();
                            })
                        } else {
                            scope.$apply(function () {
                                scope.falseToggle()
                            })
                        }

                    });
                }
            });*/
        }
    };
});
// keyCode: {
//     ALT: 18,
//         BACKSPACE: 8,
//         CAPS_LOCK: 20,
//         COMMA: 188,
//         COMMAND: 91,
//         COMMAND_LEFT: 91, // COMMAND
//         COMMAND_RIGHT: 93,
//         CONTROL: 17,
//         DELETE: 46,
//         DOWN: 40,
//         END: 35,
//         ENTER: 13,
//         ESCAPE: 27,
//         HOME: 36,
//         INSERT: 45,
//         LEFT: 37,
//         MENU: 93, // COMMAND_RIGHT
//         NUMPAD_ADD: 107,
//         NUMPAD_DECIMAL: 110,
//         NUMPAD_DIVIDE: 111,
//         NUMPAD_ENTER: 108,
//         NUMPAD_MULTIPLY: 106,
//         NUMPAD_SUBTRACT: 109,
//         PAGE_DOWN: 34,
//         PAGE_UP: 33,
//         PERIOD: 190,
//         RIGHT: 39,
//         SHIFT: 16,
//         SPACE: 32,
//         TAB: 9,
//         UP: 38,
//         WINDOWS: 91 // COMMAND
// }


// WEBPACK FOOTER //
// ./js/directive/pressKey.js